import script from "./indicatorstandards.vue?vue&type=script&setup=true&lang=js"
export * from "./indicatorstandards.vue?vue&type=script&setup=true&lang=js"

import "./indicatorstandards.vue?vue&type=style&index=0&id=01c028f6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c028f6"]])

export default __exports__